import type { McpCatalogResponseDto } from '@inference.engine/api-client/web';

export interface CredentialFormValues {
  oauthClientId?: string;
  oauthClientSecret?: string;
}

/**
 * What to send for the two credential fields, which are not a plain read-modify-write: the secret
 * is never returned, so an untouched field has to mean "leave it as it is" rather than "clear it".
 *
 * Omitting a field leaves the stored value alone, null clears it, a value replaces it. Clearing the
 * client id clears the secret with it, since a secret identifies nothing on its own — which is also
 * what makes emptying both fields a complete removal.
 */
export const credentialFields = (
  data: CredentialFormValues,
  editing: McpCatalogResponseDto | null,
): { oauthClientId?: string | null; oauthClientSecret?: string | null } => {
  if (!editing) {
    return {
      oauthClientId: data.oauthClientId || undefined,
      oauthClientSecret: data.oauthClientSecret || undefined,
    };
  }
  const clientId = data.oauthClientId ?? '';
  const changed = clientId !== (editing.oauthClientId ?? '');
  return {
    ...(changed && { oauthClientId: clientId || null }),
    ...(changed && !clientId && { oauthClientSecret: null }),
    ...(data.oauthClientSecret && { oauthClientSecret: data.oauthClientSecret }),
  };
};
